export default {
    host: 'cn-shenzhen.log.aliyuncs.com',
    project: 'zzcnext',
    performanceLogstore: 'monitor_front',
    errorLogstore: 'monitor_front_error_log',
    events: ['load', 'error'] // 需要添加到入口函数监听的系统事件名
};
